import React, { memo } from 'react';
import { usePatientDetailsTimer } from '@/hooks/patient/usePatientDetailsTimer.ts';
import { Button } from '@/components/ui/button';
import { Play, Pause, Clock } from 'lucide-react';

interface PatientDetailsTimerProps {
  patientId: number | null;
  className?: string;
}

export const PatientDetailsTimer: React.FC<PatientDetailsTimerProps> = memo(({ 
  patientId, 
  className = '' 
}) => {
  const timer = usePatientDetailsTimer(patientId);

  if (!timer.isVisible) {
    return null;
  }

  const timerDisplayClasses = [
    'font-mono',
    'text-sm',
    'font-bold',
    'text-blue-800',
    'tracking-wide'
  ].join(' ');

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 px-4 py-2 rounded-lg flex items-center space-x-3 shadow-sm">
      {/* Timer Display */}
      <Clock className="h-4 w-4 text-blue-600" />
      <div className="flex items-center space-x-2">
        <div className={timerDisplayClasses}>
          {timer.formattedTime}
        </div>
      </div>

      {/* Play/Pause Button */}
      <Button
        onClick={timer.toggleTimer}
        variant="outline"
        className="px-2 py-1.5 rounded-md transition-colors duration-200 bg-white hover:bg-blue-100 border-blue-300 text-blue-600 hover:text-blue-700"
        title={timer.isPaused ? 'Resume timer' : 'Pause timer'}
        type="button"
      >
        {timer.isPaused ? (
          <Play className="h-3 w-3" />
        ) : (
          <Pause className="h-3 w-3" />
        )}
      </Button>
    </div>
  );
});

PatientDetailsTimer.displayName = 'PatientDetailsTimer';
